import { forwardRef } from 'react';

import {
  Typography as Text,
  TypographyProps as TextProps,
  WithStyles,
  createStyles,
  withStyles,
} from '@material-ui/core';

import classNames from 'classnames';

const styles = createStyles({
  root: {},
});

export interface ExpressionPropertyProps
  extends Omit<TextProps, 'classes'>,
    WithStyles<typeof styles> {}

const ExpressionProperty = forwardRef<HTMLDivElement, ExpressionPropertyProps>(
  (props, ref) => {
    const { classes, className, ...rest } = props;
    return (
      <Text
        ref={ref}
        className={classNames(className, classes?.root)}
        {...rest}
      />
    );
  },
);

ExpressionProperty.displayName = 'Expression.Property';

export default withStyles(styles)(ExpressionProperty);
